// src/context/AuthContext.js
import { createContext, useState, useEffect } from 'react';
import axiosInstance from '../axiosInstance';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  /* ─────────────────────── refreshUser ─────────────────────── */
  const refreshUser = async () => {
  try {
    const { data } = await axiosInstance.get('auth/me');
    console.log('[AuthContext] /me response:', data);
    if (data && Object.keys(data).length) {
      // Add displayName like the login function does
      const displayName =
        `${data.firstName || ''} ${data.lastName || ''}`.trim() ||
        data.email ||
        'friend';
      const userData = { ...data, displayName };
      console.log('[AuthContext] Setting user:', userData);
      setUser(userData);
      return true;
    } else {
      setUser(null);
      return false;
    }
  } catch (err) {
    console.error('[AuthContext] Error fetching /me:', err);
    setUser(null);
    return false;
  }
};

  /* ─────────────────────── run once on mount ─────────────────────── */
  useEffect(() => {
    (async () => {
      await refreshUser();
      setLoading(false);
    })();
  }, []);

  /* ─────────────────────── helpers ─────────────────────── */
  const login  = (userObj) => {
    const displayName =
      `${userObj.firstName || ''} ${userObj.lastName || ''}`.trim() ||
      userObj.email ||
      'friend';
    setUser({ ...userObj, displayName });
  };

  const logout = async () => {
    try { await axiosInstance.post('auth/logout'); } catch {}
    setUser(null);
  };

  const value = {
    user,                    // object with displayName
    isAuthenticated: !!user, // boolean
    login,
    logout,
    refreshUser,
  };

  if (loading) return null; // could be a spinner

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
